import React from 'react'
import Layout from '../../common/Layout'
import PendingApprovalProfilesListContainer from '../../features/AdministrationPortal/PendingApprovalProfiles'
import AdviserProfileApprovalEditorContainer from '../../features/AdministrationPortal/AdviserProfileApprovalEditor/AdviserProfileApprovalEditorContainer/AdviserProfileApprovalEditorContainer'
import 'bootstrap/dist/css/bootstrap.min.css';

export default {
  path: '/administration',
  children: [{
    path: '/pendingapprovalAdviserProfiles',
    async action () {
      return {
        title: 'Adviser Profiles Pending Administrative Approval',
        component: <Layout containerWell>
          <PendingApprovalProfilesListContainer />
        </Layout>
      }
    }
  }, {
    path: '/pendingapprovalAdviserProfiles/:adviserId/edit',
    async action ({ params }) {
      return {
        title: 'Adviser Profiles Pending Administrative Approval',
        component: <Layout containerWell>
          <AdviserProfileApprovalEditorContainer adviserId={parseInt(params.adviserId)} />
        </Layout>
      }
    }
  }]
}
